enum Roles {
    employee = 1,
    manager = 2,
    admin = 3,
    comp_manager = 4
}

export default Roles;